
import ProviderDashboardLayout from '../components/ProviderDashboardLayout';
import {StoreMapRefactored} from '../../../Presentation/components/common/StoreMapRefactored';
import CityMapControls from '../../../Presentation/components/common/CityMapControls';
import {useProviderStoresMap} from '../../stores/hooks/useProviderStoresMap';
import {useStoreSelectionStore} from '../../stores/store/StoreSelectionStore';
import StoreDetails from '../../../Presentation/components/common/StoreDetails';
import {AlertCircle} from 'lucide-react';
import {useAuth} from '../../auth/hooks/useAuth';

export default function ProviderDashboard () {
  const {user} = useAuth();
  const {error: providerStoresError} = useProviderStoresMap(true);
  const {selectedStore} = useStoreSelectionStore();

  return (
    <ProviderDashboardLayout>
      <div className="h-full flex flex-col gap-6 p-6">
        {/* Error Messages */}
        {providerStoresError && (
          <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg">
            <AlertCircle className="w-5 h-5 text-red-500" />
            <span className="text-red-700">
              خطأ في تحميل المتاجر: {String(providerStoresError)}
            </span>
          </div>
        )}

        {/* Provider Info Banner */}
        <div className="bg-brand-50 border border-brand-200 rounded-lg p-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-brand-100 rounded-full flex items-center justify-center">
              <span className="text-brand-600 font-semibold text-sm">🗺️</span>
            </div>
            <div>
              <h3 className="text-sm font-medium text-brand-900">
                خريطة المتاجر
              </h3>
              <p className="text-xs text-brand-700">
                عرض المتاجر التي تحتوي على منتجات من البراندات المرتبطة بك: {
                  user?.getAssignedBrandNames
                    ? user.getAssignedBrandNames().join(', ')
                    : (user as any)?.providerData?.assignedBrands?.map((b: any) => b.name).join(', ') || 'لا توجد براندات مرتبطة'
                }
              </p>
            </div>
          </div>
        </div>

        {/* Main Content - Map Only */}
        <div className="flex-1 flex flex-col lg:flex-row gap-6">
          {/* Left Column - Map and Controls */}
          <div className="flex-1 flex flex-col space-y-4">
            {/* City Map Controls */}
            <CityMapControls />

            {/* Map - Takes most of the space */}
            <div className="flex-1">
              <StoreMapRefactored viewMode="stores" />
            </div>
          </div>

          {/* Store Details - Smaller panel */}
          {selectedStore && (
            <div className="w-full lg:w-[350px] min-h-[400px] lg:min-h-full">
              <StoreDetails store={selectedStore} />
            </div>
          )}
        </div>
      </div>
    </ProviderDashboardLayout>
  );
}
